import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ADMIN_API_URL } from "../../constants";
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const SearchLeadPage = ({ addNotification }) => {
    const navigate = useNavigate();
    const [mobile, setMobile] = useState('');
    const [leadId, setLeadId] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [searchError, setSearchError] = useState(null);

    const handleSearch = async () => {
        if (!mobile && !leadId) {
            addNotification('Please enter either Mobile Number or Lead ID', 'error');
            return;
        }

        const token = sessionStorage.getItem("authToken");
        if (!token) {
            addNotification('Authorization token not found. Please log in again.', 'error');
            navigate("/");
            return;
        }

        setIsSearching(true);
        setSearchError(null);

        try {
            const response = await fetch(`${ADMIN_API_URL}fetch-lead-data`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "authorization": `${token}`,
                },
                body: JSON.stringify({
                    minLimit: 0,
                    maxLimit: 100,
                    startDate: "",
                    endDate: "",
                    productType: "",
                    loanAmount: "",
                    mobile: mobile,
                    leadId: leadId,
                    assignedTo: "",
                    lenderId: "",
                    sortBy: "createdAt",
                    sortOrder: "DESC"
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Failed to fetch lead data");
            }

            if (result.data) {
                const dataArray = Array.isArray(result.data) ? result.data : [result.data];
                if (dataArray.length > 0) {
                    setSearchResults(dataArray);
                    setSearchError(null);
                } else {
                    setSearchResults([]);
                    setSearchError("No lead found with the provided details.");
                    addNotification('No lead found with the provided details.', 'info');
                }
            } else {
                setSearchResults([]);
                setSearchError("No lead found with the provided details.");
                addNotification('No lead found with the provided details.', 'info');
            }

        } catch (error) {
            console.error("Error searching lead:", error);
            setSearchResults([]);
            setSearchError(error.message);
            addNotification(`Error searching lead: ${error.message}`, 'error');
        } finally {
            setIsSearching(false);
        }
    };

    const handleClearFilter = () => {
        setMobile('');
        setLeadId('');
        setSearchResults([]);
        setSearchError(null);
    };

    const handleViewDetails = (lead) => {
        navigate(`/leads/${lead.id}`);
    };

    const getUserNameById = (userId) => {
        if (!userId) return 'N/A';
        return 'N/A'; // Since we don't have users list here
    };

    return (
        <>
            <Header />
            <div id="wrapper" style={{ paddingTop: '70px' }}>
                <div className="content">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hpanel">
                                <div className="panel-body">
                                    <h2 className="font-light m-b-xs">Search Lead</h2>
                                    <p className="text-muted m-b-md">Search by Mobile Number or Lead ID to view application details</p>
                                    
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="row">
                                                <div className="form-group col-sm-6">
                                                    <label htmlFor="mobile">Mobile:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="mobile"
                                                        value={mobile}
                                                        onChange={(e) => {
                                                            const value = e.target.value.replace(/[^0-9]/g, '');
                                                            if (value.length <= 10) {
                                                                setMobile(value);
                                                            }
                                                        }}
                                                        maxLength="10"
                                                        placeholder="Enter 10-digit mobile number"
                                                        disabled={isSearching}
                                                    />
                                                </div>
                                                <div className="form-group col-sm-6">
                                                    <label htmlFor="leadId">Lead ID:</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="leadId"
                                                        value={leadId}
                                                        onChange={(e) => setLeadId(e.target.value)}
                                                        placeholder="Enter Lead ID"
                                                        disabled={isSearching}
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="form-group col-sm-12" style={{ marginTop: '15px' }}>
                                                    <button 
                                                        className="btn btn-primary" 
                                                        onClick={handleSearch}
                                                        disabled={isSearching}
                                                    >
                                                        {isSearching ? (
                                                            <>
                                                                <i className="fa fa-spinner fa-spin"></i> Searching...
                                                            </>
                                                        ) : (
                                                            'Filter'
                                                        )}
                                                    </button>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-default ml-2" 
                                                        onClick={handleClearFilter}
                                                        style={{ marginLeft: '10px' }}
                                                        disabled={isSearching}
                                                    >
                                                        Clear Filter
                                                    </button>
                                                </div>
                                            </div>

                                            {searchError && searchResults.length === 0 && (
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="alert alert-warning m-t-md">
                                                            <i className="fa fa-info-circle"></i> {searchError}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Search Results Table */}
                    {searchResults.length > 0 && (
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="hpanel">
                                    <div className="panel-heading">
                                        <div className="panel-tools">
                                            <a className="showhide"><i className="fa fa-chevron-up"></i></a>
                                            <a className="closebox"><i className="fa fa-times"></i></a>
                                        </div>
                                        Search Results
                                    </div>
                                    <div className="panel-body">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th style={{ minWidth: '180px' }}>Created At</th>
                                                        <th style={{ minWidth: '150px' }}>Application ID</th>
                                                        <th style={{ minWidth: '150px' }}>Product Type</th>
                                                        <th style={{ minWidth: '150px' }}>Mobile</th>
                                                        <th style={{ minWidth: '150px' }}>Loan Amount</th>
                                                        <th style={{ minWidth: '150px' }}>Lead Status</th>
                                                        <th style={{ minWidth: '150px' }}>App Progress</th>
                                                        <th style={{ minWidth: '150px' }}>Remarks</th>
                                                        <th style={{ minWidth: '150px' }}>Assigned Lender</th>
                                                        <th style={{ minWidth: '150px' }}>Customer ID</th>
                                                        <th style={{ minWidth: '150px' }}>Customer Name</th>
                                                        <th style={{ minWidth: '150px' }}>Email</th>
                                                        <th style={{ minWidth: '150px' }}>Assigned To</th>
                                                        <th style={{ minWidth: '150px' }}>Source</th>
                                                        <th style={{ minWidth: '150px' }}>Follow-up Date</th>
                                                        <th style={{ minWidth: '150px' }}>Created By</th>
                                                        <th style={{ minWidth: '180px' }}>Last Updated</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {searchResults.map((lead) => (
                                                        <tr key={lead.id}>
                                                            <td style={{ minWidth: '180px' }}>{lead.createdAt || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>
                                                                <span 
                                                                    className="text-primary" 
                                                                    style={{ 
                                                                        cursor: 'pointer',
                                                                        textDecoration: 'underline',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '5px',
                                                                        transition: 'all 0.2s ease',
                                                                        fontWeight: '500'
                                                                    }}
                                                                    onClick={() => handleViewDetails(lead)}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.color = '#0056b3';
                                                                        e.target.style.textDecoration = 'underline';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.color = '';
                                                                        e.target.style.textDecoration = 'underline';
                                                                    }}
                                                                >
                                                                    <i className="fa fa-file-text-o"></i>
                                                                    {lead.id || 'N/A'}
                                                                </span>
                                                            </td>
                                                            <td style={{ minWidth: '150px' }}>{lead.productType || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>
                                                                {lead.mobile || 'N/A'}
                                                                {typeof lead.isMobileVerified === 'boolean' && (
                                                                    <span
                                                                        title={lead.isMobileVerified ? 'Mobile Verified' : 'Mobile Not Verified'}
                                                                        style={{
                                                                            marginLeft: 8,
                                                                            color: lead.isMobileVerified ? 'green' : 'red',
                                                                            fontSize: '16px',
                                                                            verticalAlign: 'middle',
                                                                        }}
                                                                    >
                                                                        <i className={`fa ${lead.isMobileVerified ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td style={{ minWidth: '150px' }}>{lead.loanAmount || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>{lead.leadStatus || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>No Progress</td>
                                                            <td style={{ minWidth: '150px' }}>
                                                                {lead.remarks ? (
                                                                    <span className="text-primary" style={{ cursor: 'pointer' }}>
                                                                        <i className="fa fa-eye"></i> View Notes
                                                                    </span>
                                                                ) : (
                                                                    'N/A'
                                                                )}
                                                            </td>
                                                            <td style={{ minWidth: '150px' }}>
                                                                {lead.lenderInfo?.lenderId || 'N/A'}
                                                            </td>
                                                            <td style={{ minWidth: '150px' }}>{lead.customerId || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>{lead.customerName || lead.name || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>{lead.email || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>{getUserNameById(lead.assignedTo)}</td>
                                                            <td style={{ minWidth: '150px' }}>{lead.source || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>{lead.followUpDate || 'N/A'}</td>
                                                            <td style={{ minWidth: '150px' }}>{getUserNameById(lead.createdBy)}</td>
                                                            <td style={{ minWidth: '180px' }}>{lead.lastUpdated || 'N/A'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <Footer />
            </div>
        </>
    );
};

export default SearchLeadPage;
